import {GameBoard, GameConfig, GameData, GamePlay, GamePlayKey, GameSetup} from "../types";
import {v4 as uuid} from "uuid";

export class LetterspinLayout {

  constructor(readonly level: LetterspinDifficultyLevel, readonly allWords: string[], readonly word: string) {
  }
}

export class LetterspinDifficultyLevel {

  static readonly VALUES = new Array<LetterspinDifficultyLevel>(3);
  static readonly EASY = LetterspinDifficultyLevel.VALUES[0] = new LetterspinDifficultyLevel("easy", "Easy", "Easy desc", 7);
  static readonly MEDIUM = LetterspinDifficultyLevel.VALUES[1] = new LetterspinDifficultyLevel("medium", "Medium", "Medium desc", 6);
  static readonly HARD = LetterspinDifficultyLevel.VALUES[2] = new LetterspinDifficultyLevel("hard", "Hard", "Hard desc", 5);

  constructor(readonly name: string, readonly text: string, readonly description: string, readonly maxTries: number) {
  }
}

export class LetterspinGameConfig extends GameConfig {

  constructor(readonly level: LetterspinDifficultyLevel) {
    super();
  }
}

export class LetterspinGameSetup extends GameSetup {

  constructor(key: GamePlayKey) {
    super(key);
  }
}

export class LetterspinGameData extends GameData<LetterspinGameBoard> {

  static async create(config: LetterspinGameConfig): Promise<LetterspinGameData> {
    const loader = new LetterspinGamesLoader();
    const layout = await loader.getRandomGame(config.level);
    const setup = new LetterspinGameSetup(new GamePlayKey("letterspin", uuid()));
    const now = Date.now();
    return new LetterspinGameData(new GamePlay(setup, now, 0, 0, 0, new LetterspinGameBoard(config.level, layout)));
  }
}

export class LetterspinGamesLoader {

  async getRandomGame(level: LetterspinDifficultyLevel): Promise<LetterspinLayout> {
    const words = (await fetch("/games/letterspin/words.txt").then(result => result.text())).split("\n");
    const allWords = (await fetch("/games/letterspin/all-words.txt").then(result => result.text())).split("\n");
    return new LetterspinLayout(level, allWords, words[Math.floor(Math.random() * words.length)]);
  }
}

export class LetterspinGameBoard extends GameBoard {

  readonly enteredWords: string[][] = [];
  readonly currentWord: string[] = [];

  constructor(readonly level: LetterspinDifficultyLevel, readonly layout: LetterspinLayout) {
    super();
  }

  getPoints(moves: number): number {
    return (8 - moves) * 50;
  }

  toJSON(): any {
    return this;
  }
}